module.exports = __webpack_public_path__ + "img/welcome.0f6ec56c.gif";